import { memo, useEffect, useState, useContext, useRef } from 'react';
import { Link } from "react-router-dom";
import TextTruncate from 'react-text-truncate';
import { useCookies } from 'react-cookie'

import '../css/Cats.css'

import { Img } from "../Elements";

import { MdAddShoppingCart } from "react-icons/md";


export default function Cats({ data }) {

    return (
        <Link to={`/cat/${data?._id}`} className='catsBox'>
            <Img src={`img/200x200/${data?.img}`} />
            <section>
                <h3>{data?.name}</h3>
            </section>
            
        </Link>
    );
}
